document.addEventListener("DOMContentLoaded", function () {
  const countryCode = document.body.getAttribute("data-country-code");
  const country = taxData.find(c => c.code === countryCode);
  const taxRate = country ? country.tax : 0;

  function updatePriceWithVAT() {
      const priceElem = document.querySelector("[data-render-price='main-product'] .sale-price") || 
                        document.querySelector("[data-render-price='main-product'] .regular-price");
      const priceIncTaxElem = document.getElementById("price-inc-tax");
      const priceIncTaxContainer = document.getElementById("price-inc-tax-container");
  
      if (priceElem && priceIncTaxElem && priceIncTaxContainer) {
          let rawPrice = priceElem.textContent.trim();
          let currencySymbol = rawPrice.match(/[€£$]/)?.[0] || ""; // Extract currency symbol
  
          let isEuropean = currencySymbol === "€"; 
  
          let priceExTax = parseFloat(rawPrice
              .replace(currencySymbol, "") // Remove currency symbol
              .replace(isEuropean ? /\./g : /,/g, "") // Remove thousands separator
              .replace(isEuropean ? /,/g : /\./g, ".") // Convert decimal separator
          );
  
          if (isNaN(priceExTax)) return;
  
          let priceIncTax = priceExTax * (1 + taxRate);
  
          console.warn('Detected currency:', currencySymbol, '| Country currency:', country.currency);
  
          // Use correct locale for formatting
          let locale = country.currency === "EUR" ? "de-DE" : "en-GB";
          let formattedPrice = new Intl.NumberFormat(locale, {
              style: "currency",
              currency: country.currency
          }).format(priceIncTax);
  
         // Manually adjust currency symbol placement
          if (currencySymbol === "€") {
              // Remove the euro symbol from the formatted price (if it exists)
              formattedPrice = formattedPrice.replace('€', '').trim();
              // Add the euro symbol at the front of the formatted price
              formattedPrice = `€${formattedPrice}`;
          }
  
          priceIncTaxElem.textContent = formattedPrice;
  
          priceIncTaxContainer.style.display = "block";
      }
  }

  // Run on page load
  updatePriceWithVAT();

  // Listen for variant selection
  document.querySelectorAll(".product-variant-option input[type='radio']").forEach((input) => {
    input.addEventListener("change", updatePriceWithVAT);
  });

  // Use MutationObserver to detect Shopify’s dynamic price updates
  const targetNode = document.querySelector("[data-render-price='main-product']");
  if (targetNode) {
    const observer = new MutationObserver(() => {
      updatePriceWithVAT();
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const body = document.querySelector("body");
  const countryCode = body?.getAttribute("data-country-code");
  const taxMessages = document.querySelectorAll(".main-cart_tax-note, .cart-drawer_tax-note");

  if (taxMessages.length > 0 && countryCode && countryCode !== "GB") {
    taxMessages.forEach((taxMessage) => {
      taxMessage.innerText =
        "Shipping fees are calculated during checkout. Local taxes and duties may apply.";
    });
  }
});